module.exports = __webpack_public_path__ + "static/media/phone-final.ea205839.svg";